import { IEquity } from '@modeso/types__aumico-lib-annualreport-be';

export interface IEquityDelegate {
    equityComponentData(equityData: IEquity, componentIndex: number);
}
